"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var acdcContext = react_1.createContext(null);
exports.useAcdcContext = function () { return react_1.useContext(acdcContext); };
exports.AcdcProvider = acdcContext.Provider;
exports.AcdcConsumer = acdcContext.Consumer;
var acdcElementRegistryContext = react_1.createContext(null);
exports.useAcdcElementRegistryContext = function () { return react_1.useContext(acdcElementRegistryContext); };
exports.AcdcElementRegistryProvider = acdcElementRegistryContext.Provider;
exports.AcdcElementRegistryConsumer = acdcElementRegistryContext.Consumer;
